import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const DATE_LABELS = { coffee: '☕ Coffee', dinner: '🍽️ Dinner', lunch: '🥐 Lunch' };

const InviteSend = ({ invite, choices, onSend, sending }) => {
  const dateLabel = choices.dateType === 'custom' ? `✨ ${choices.customType}` : (DATE_LABELS[choices.dateType] || choices.dateType);
  const senderName = invite.sender_profile?.name || 'them';

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="w-full max-w-sm p-6 text-center">
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Ready to send your plan?</h2>
      <p className="text-gray-500 text-sm mb-6">Your date plan will be sent to {senderName}</p>
      <div className="bg-gradient-to-b from-pink-50 to-white rounded-2xl border border-pink-200 p-6 mb-6 text-left">
        <div className="text-center mb-4">
          <p className="text-xs text-pink-400 font-semibold uppercase">Your Date Plan</p>
        </div>
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <span className="text-lg">{dateLabel.split(' ')[0]}</span>
            <span className="font-medium text-gray-700">{dateLabel}</span>
          </div>
          <div className="flex items-center gap-3">
            <SafeIcon name="Calendar" className="text-pink-500" />
            <span className="text-gray-700">
              {choices.eventDate ? new Date(choices.eventDate + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric' }) : ''}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <SafeIcon name="Clock" className="text-pink-500" />
            <span className="text-gray-700">{choices.eventTime}</span>
          </div>
          {choices.message && (
            <div className="flex items-start gap-3">
              <SafeIcon name="MessageCircle" className="text-pink-500 mt-0.5" />
              <span className="text-gray-700 italic text-sm">"{choices.message}"</span>
            </div>
          )}
        </div>
      </div>
      <button
        onClick={onSend} disabled={sending}
        className="w-full bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-pink-200 disabled:opacity-60 flex items-center justify-center gap-2 text-lg"
      >
        {sending ? (<><div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />Sending...</>) : (<>Send to {senderName} <SafeIcon name="Send" /></>)}
      </button>
    </motion.div>
  );
};

export default InviteSend;